module.exports = __webpack_public_path__ + "static/20230619_021-1afed3b9b0f08d97a40d5620ac2f8592.jpg";